import produce from 'immer';
import { PositionType, useAuthStateStore } from '@annunciate/core';
import { syncProgress } from './syncProgress';
import { getContentAssetDuration } from './getContentAssetDuration';
export const updateCachedProgress = async (client, { contentId, position, sync = false }) => {
    const uuid = useAuthStateStore.getState().getUUID(true);
    const cacheKey = [`progress`, { contentId, uuid }];
    const data = client.getQueryData(cacheKey);
    const duration = await getContentAssetDuration(contentId, data);
    client.setQueryData(cacheKey, (old) => {
        const toUpdate = old || {
            __typename: 'Progress',
            contentId,
            uuid,
            position: null,
        };
        return produce(toUpdate, (draft) => {
            const now = (new Date()).toISOString();
            switch (position?.type) {
                case PositionType.TIME:
                    position.value = Math.ceil(position.value);
                    break;
                default:
                    break;
            }
            if (draft) {
                draft.position = position;
                draft.staleAt = now;
                draft.duration = draft.duration || duration;
                return draft;
            }
            else {
                return {
                    __typename: 'Progress',
                    contentId,
                    uuid,
                    position,
                    duration,
                    staleAt: now,
                };
            }
        });
    });
    if (sync === true) {
        await syncProgress(client);
    }
};
//# sourceMappingURL=updateCachedProgress.js.map